import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivilageIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivilageIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.8999 22.9102C7.38571 22.9102 2.8999 18.4248 2.8999 12.9106C2.8999 7.39645 7.38571 2.91016 12.8999 2.91016C14.8704 2.91016 16.7771 3.48296 18.4136 4.56579C18.6451 4.7188 18.7084 5.0307 18.5553 5.26218C18.4014 5.4917 18.0904 5.55741 17.8594 5.40341C16.3877 4.42945 14.6727 3.91452 12.8999 3.91452C7.93988 3.91452 3.90427 7.94964 3.90427 12.9097C3.90427 17.8697 7.93988 21.9058 12.8999 21.9058C17.8599 21.9058 21.8955 17.8707 21.8955 12.9106C21.8955 11.7366 21.6729 10.5949 21.2345 9.51699C21.1295 9.26001 21.2531 8.96675 21.5101 8.86278C21.7661 8.75783 22.0603 8.88043 22.1643 9.13838C22.6522 10.337 22.8999 11.6052 22.8999 12.9097C22.8999 18.4238 18.4141 22.9102 12.8999 22.9102Z"
        fill="#50D77A"
      />
      <path
        d="M12.6258 15.043C12.5012 15.043 12.3766 14.9969 12.28 14.9047L8.83144 11.6277C8.63037 11.4365 8.62203 11.1187 8.81329 10.9176C9.00406 10.7165 9.32234 10.7097 9.52292 10.8999L12.6233 13.8454L22.049 4.75214C22.2496 4.5599 22.5669 4.56382 22.7592 4.7649C22.9519 4.964 22.946 5.28179 22.7464 5.47403L12.9744 14.9017C12.8773 14.9959 12.7513 15.043 12.6258 15.043Z"
        fill="#50D77A"
      />
    </svg>
  );
};

export default PrivilageIcon;
